import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LaunchDarklyInterface } from './launch-darkly.interface';

@Injectable({
  providedIn: 'root'
})
export class LaunchDarklyService extends LaunchDarklyInterface {
  token: string;
  allowMocks = false;

  constructor(public http: HttpClient) {
    super(http);
  }

  getRAFFlag(): boolean {
    return this.tryGetFlagBoolean('refer-a-friend');
  }

  getCTG88Flag(): string {
    return this.tryGetFlagString('ctg-88-nudge-content-on-board-clear');
  }

  getCWDT1119Flag(): boolean {
    return this.tryGetFlagBoolean('cwdt-1119-segment-notification-page');
  }

  getCWDT1119VariantFlag(): boolean {
    return this.tryGetFlagBoolean(
      'cwdt-1119-variant-segment-notifications-page'
    );
  }

  getGLB723Flag(): boolean {
    return this.tryGetFlagBoolean(
      'glb-723-glba-fe-iso-segment-first-identify-page-and-track-events'
    );
  }

  getCWDT1187Flag(): boolean {
    return this.tryGetFlagBoolean(
      'cwdt-1187-show-special-tile-ui-on-certain-missions'
    );
  }

  getCWDT1187VariantFlag(): boolean {
    return this.tryGetFlagBoolean(
      'cwdt-1187-variant-show-special-tile-ui-on-certain-missions'
    );
  }

  getCWDT803Flag(): boolean {
    return this.tryGetFlagBoolean('cwdt-803-screen-attribution-overlay');
  }

  getCWDT1308Flag(): Array<string> {
    return this.tryGetFlagJSON('cwdt-1308-special-tile-snack-bar-copy');
  }

  getCWDT1376Flag(): boolean {
    return this.tryGetFlagBoolean('cwdt-1376-spring-theme');
  }

  getCWDT1376SM1612Flag(): boolean {
    return this.tryGetFlagBoolean('cwdt-1376-sm-1612-spring-theme');
  }

  getCWDT1448Flag(): boolean {
    return this.tryGetFlagBoolean('cwdt-1448-points-pill-tooltip-flag');
  }

  getCWDT1182Flag(): boolean {
    return this.tryGetFlagBoolean('cwdt-1182-challenge-missions-completed-v-1');
  }

  getCWDT1182SM1691Flag(): boolean {
    return this.tryGetFlagBoolean(
      'cwdt-1182-sm-1691-challenge-missions-completed-v-1'
    );
  }

  getCWDT1562SM1709Flag(): boolean {
    return this.tryGetFlagBoolean('cwdt-1562-sm-1709-summer-theme');
  }

  getCWDT1562Flag(): boolean {
    return this.tryGetFlagBoolean('cwdt-1562-summer-theme');
  }

  getCWDT1372Flag(): boolean {
    return this.tryGetFlagBoolean(
      'cwdt-1372-ability-to-set-a-reward-goal-during-sign-up'
    );
  }

  getSDOM358AddVisaGiftCard(): boolean {
    return this.tryGetFlagBoolean(
      'sdom-358-add-feature-flag-to-visa-gift-card'
    );
  }

  getSDOM747MakeMissionSpecialTileFlag(): string[] {
    return this.tryGetFlagJSON('sdom-747-make-mission-special-tile');
  }

  getCWDT24102411HolidayStreakMilestoneModalFlag(): any[] {
    return this.tryGetFlagJSON('cwdt-2410-2411-holiday-streak-milestone-modal');
  }

  getPlg161UpdateProfilePointsBanner(): number {
    return this.tryGetFlagNumber('plg-161-update-profile-points-banner');
  }

  getCWDT1847SM1879Flag(): boolean {
    return this.tryGetFlagBoolean('cwdt-1847-sm-1879-7-day-streak-challenge');
  }

  getCWDT2328MoveSMSQuestionFlag(): boolean {
    return this.tryGetFlagBoolean(
      'cwdt-2328-2329-move-sms-prior-to-profile-screens'
    );
  }

  getRW74And76AbilityToSignUpWithAMagicLink() {
    return this.tryGetFlagBoolean(
      'rw-74-76-ability-to-sign-up-with-a-magic-link'
    );
  }

  getCWDT2541And2542AddVenmoAndPayPalRewards(): boolean {
    return this.tryGetFlagBoolean('cwdt-2541-2542-add-venmo-and-paypal-reward');
  }

  getCWDT2108And2417ShowTimeOnTiles(): boolean {
    return this.tryGetFlagBoolean('cwdt-2108-2417-show-time-on-tiles');
  }

  getRW80And104ShowSmsPromptsToUsers() {
    return this.tryGetFlagBoolean('rw-80-104-show-sms-prompts-to-users');
  }

  getCWDT2647And2648ShowPointsOnTiles(): boolean {
    return this.tryGetFlagBoolean('cwdt-2647-2648-show-points-on-tiles');
  }

  getCWDT2433And2434AddTileTooltip(): boolean {
    return this.tryGetFlagBoolean('cwdt-2433-2434-add-tile-tooltip');
  }
}
